import { render, staticRenderFns } from "./zzglList.vue?vue&type=template&id=455eec0e&scoped=true"
import script from "./zzglList.vue?vue&type=script&lang=js"
export * from "./zzglList.vue?vue&type=script&lang=js"
import style0 from "./zzglList.vue?vue&type=style&index=0&id=455eec0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455eec0e",
  null
  
)

export default component.exports